// !delete function isInt
// 2sd - ситается числом у этой функции.. c !Number.isNaN(+str) все нормально работает
export function isInt(str) {
  return !Number.isNaN(+str) && Number.isInteger(parseFloat(str, 10));
}

/**
 * @param {string} text где искать
 * @param {string} searchText что искать
 * @returns {boolean}
 */
export function isTextIncludesSearchText(text, searchText) {
  return text?.toUpperCase().includes(searchText.toUpperCase());
}
// Native
// var object = { a: [{ b: { c: 3 } }] };
// var result = getPath(object, 'a[0].b.c', 1);
export const getPath = (obj, path, defaultValue = undefined) => {
  const travel = (regexp) => String.prototype.split
    .call(path, regexp)
    .filter(Boolean)
    .reduce((res, key) => (res !== null && res !== undefined ? res[key] : res), obj);
  const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
  return result === undefined || result === obj ? defaultValue : result;
};

/**
 * Функция, которые обнуляет свойства-массивы
 * @param {object} obj объект, в котором нужно обнулить массивы
 * @returns {object} объект с обнуленными свойствами-массивами
 * @example
 * {
 *   id: 1,
 *   prop: [1,2,3]
 * }
 * станет
 * {
 *   id: 1,
 *   prop: null
 * }
 */
export function nullifyArrayProps(obj) {
  const tmp = { ...obj };
  Object.keys(tmp).forEach((key) => {
    if (Array.isArray(tmp[key])) tmp[key] = null;
  });
  return tmp;
}

// Регулярка для ролей (исключает системные роли)
export const userRoleRegex = /^RS_.*/;
